(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('TipoOrdenamientoDialogController', TipoOrdenamientoDialogController);

    TipoOrdenamientoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TipoOrdenamiento', 'Norma'];

    function TipoOrdenamientoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TipoOrdenamiento, Norma) {
        var vm = this;

        vm.tipoOrdenamiento = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tipoOrdenamiento.id !== null) {
                TipoOrdenamiento.update(vm.tipoOrdenamiento, onSaveSuccess, onSaveError);
            } else {
                TipoOrdenamiento.save(vm.tipoOrdenamiento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:tipoOrdenamientoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
